<template>
  <div
    class="flex overflow-hidden rounded bg-white shadow-normal shadow-gray-400"
  >
    <TheNuxtLink
      :id="itemData.trackingCode"
      :title="itemData.name"
      :to="provideFormatUrl(itemData.link)"
      class="block flex-1 p-3"
    >
      <span
        v-if="itemData.caption"
        class="line-clamp-1 text-xs font-bold text-gray-600"
      >
        {{ itemData.caption }}
      </span>
      <h3 class="line-clamp-4 text-sm font-bold leading-6">
        {{ itemData.name }}
      </h3>
    </TheNuxtLink>
    <LightboxVideo
      v-if="itemData.wistiaCode"
      :video-data="video"
      class="h-[140px] w-[120px] basis-[120px]"
      @click.stop
    />
    <figure
      v-else
      class="relative block h-[140px] w-[120px] basis-[120px] overflow-hidden"
    >
      <img
        :src="contextThumbnail"
        :alt="itemData.name || itemData.caption"
        loading="lazy"
        class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
      />
    </figure>
  </div>
</template>

<script setup lang="ts">
  import type { IVideoData } from '@/components/Shared/Lightbox/Video.vue';
  import type { IItem } from '@/components/Shared/Suite/Resources/index.vue';
  import type { TUrlConnector } from '@/components/Shared/Suite/type.ts';

  interface IProps {
    itemData: IItem;
    urlConnector?: TUrlConnector;
  }

  const props = defineProps<IProps>();

  const { provideFormatUrl } = useFormatUrl();
  const { provideResponsiveImgUrl } = useSolutionsData();

  const video = computed(
    (): IVideoData => ({
      title: props.itemData.name,
      description: props.itemData.caption || '',
      url: props.itemData.wistiaCode || '',
      imageUrl: contextThumbnail.value,
    })
  );

  const contextThumbnail = computed((): string => {
    const { thumbnail } = props.itemData;
    if (!thumbnail) return '';

    if (props.urlConnector === 'solution') {
      return provideResponsiveImgUrl(thumbnail);
    }
    return thumbnail;
  });
</script>
